import {
  type ActivityQueries,
  defActivityQueries,
} from '@kizen/query/activities';

import AxiosService from 'services/AxiosService';

const queries: ActivityQueries = defActivityQueries(AxiosService);

export const activityQuery: ActivityQueries['activityQuery'] =
  queries.activityQuery;

export const activityFieldsQuery: ActivityQueries['activityFieldsQuery'] =
  queries.activityFieldsQuery;

export const activityHistoryQuery: ActivityQueries['activityHistoryQuery'] =
  queries.activityHistoryQuery;

export const searchScheduledActivitiesQuery: ActivityQueries['searchScheduledActivitiesQuery'] =
  queries.searchScheduledActivitiesQuery;

export const getActivityUsageQuery: ActivityQueries['getActivityUsageQuery'] =
  queries.getActivityUsageQuery;
